<template>
  <div v-if="modelValue" :class="modalOverlayClass" @click="closeOnOverlayClick && $emit('update:modelValue', false)">
    <div class="reusable-modal-parent">
      <div :class="firstLoggedIn ? 'reusable-modal'  : 'reusable-modal2'"
        :style="{ maxWidth: xlarge? '700px' : isLarge ? '550px' : '450px' }" @click.stop>
        <div class="reusable-modal-header">
          <slot name="header">
            <h2>{{ title }}</h2>
          </slot>
          <button v-if="!hideCancelButton" class="close-button" @click="$emit('update:modelValue', false)"> × </button>
          <div v-else></div>
        </div>
        <div :class="performance ? 'reusable-modal-content-performance' : 'reusable-modal-content'" :style="scrollable ? { maxHeight, overflowY: 'auto' } : {}">
          <slot></slot>
        </div>

        <div class="reusable-modal-footer">
          <slot name="footer">
          <button class="secondary-button" v-if="!hideCancelButton" @click="$emit('update:modelValue', false)">{{ cancelButtonText }}</button>
            <slot name="middle-footer"></slot>
            <button class="primary-button" @click="$emit('submit')" :disabled="loading">
              <span v-if="loading">
                <img src="/static/img/loader.gif" alt="Loading" style="width:18px; height:18px;vertical-align:middle;" />
              </span>
              <span v-else>
                {{ submitButtonText }}
              </span>
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReuseableModal',
  props: {
    fullOverlay: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    submitButtonText: {
      type: String,
      default: 'Add'
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel'
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: true
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    xlarge: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideCancelButton: { 
      type: Boolean, 
      default: false 
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: '70vh'
    },
    performance: {
      type: Boolean,
      default: false
    }
    
  },
  emits: ['update:modelValue', 'submit'],
  data() {
    return {
      isWindowLarge: window.innerWidth > 900
    };
  },
  computed: {
    firstLoggedIn() {
      const auth = this.$store.state.auth;
      if (!auth || !auth.user) {
        return false;
      }
      return !!auth.user.firstLoggedIn;
    },
    modalOverlayClass() {
      if (this.fullOverlay) return 'modal-overlay1';
      
      const path = this.$route && this.$route.path;
      const auth = this.$store.state.auth;
      const user = auth && auth.user;
      if (path === '/overview' && user && !user.firstLoggedIn) {
        return 'modal-overlay1';
      }

      return this.isWindowLarge ? 'modal-overlay2' : 'modal-overlay1';
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isWindowLarge = window.innerWidth > 900;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/ReuseableModal.vue